import "./spotlight-block.scss";